import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import VideoOverlay from './VideoOverlay';

const App = () => {
    useEffect(() => {
        // Redirect to an external website if the current path is "/"
        if (window.location.pathname === '/') {
            window.location.href = 'https://www.candywriter.com';
        }
    }, []);

    return (
        <Routes>
            {/* Catch-all route to load VideoOverlay for any other path */}
            <Route path="/*" element={<VideoOverlay />} />
        </Routes>
    );
};

const Root = () => (
    <Router>
        <App />
    </Router>
);

export default Root;